// extracted by mini-css-extract-plugin
module.exports = {"container":"NavbarMobile_container__tk37B","list":"NavbarMobile_list__3tv8M","navlink":"NavbarMobile_navlink__3HfoT","active":"NavbarMobile_active__2hxh_"};